import { render } from "./CountryIcon.vue?vue&type=template&id=2f1e1389"
import script from "./CountryIcon.vue?vue&type=script&lang=js"
export * from "./CountryIcon.vue?vue&type=script&lang=js"

import "./CountryIcon.vue?vue&type=style&index=0&id=2f1e1389&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__